/* global dataLayer */

export const trackGtmEvent = (event, payload = {}) => {
  window.dataLayer = window.dataLayer || []

  dataLayer.push({
    ...payload,
    event,
  })
}
